namespace GeniuzPOS.Inventory {
    export enum PosOrIcProcessingFgstatus {
        alltran = 1,
        alldoc = 2,
        allpos = 3
    }
    Serenity.Decorators.registerEnumType(PosOrIcProcessingFgstatus, 'GeniuzPOS.Inventory.PosOrIcProcessingFgstatus');
}
